class CountdownDisplay extends HTMLElement {
  constructor() {
    super();
    
    this.attachShadow({ mode: 'open' });
    this.template = this.closest('.shopify-block').querySelector('template');
    this.shadowRoot.appendChild(this.template.content.cloneNode(true));

    // Get elements
    this.hoursElement = this.shadowRoot.querySelector('[data-hours]');
    this.minutesElement = this.shadowRoot.querySelector('[data-minutes]');
    this.secondsElement = this.shadowRoot.querySelector('[data-seconds]');

    // Get target time from data attribute
    this.targetTimeStr = this.dataset.resetTime;
  }

  connectedCallback() {
    this.updateDisplay();
    this.interval = setInterval(() => this.updateDisplay(), 1000);
  }

  disconnectedCallback() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  parseTimeString(timeStr) {
    const [hours, minutes, seconds] = timeStr.split(':').map(Number);
    return { hours, minutes, seconds };
  }

  calculateTimeLeft() {
    const now = new Date();
    const target = new Date();
    const { hours, minutes, seconds } = this.parseTimeString(this.targetTimeStr);
    
    // Set target time for today
    target.setHours(hours, minutes, seconds, 0);
    
    // If target time has passed today, set for tomorrow
    if (now > target) {
      target.setDate(target.getDate() + 1);
    }
    
    // Calculate time difference in milliseconds
    let diff = target - now;
    
    // Add 30 minutes (1800000 milliseconds)
    diff += 1800000;
    
    // Convert to hours, minutes, seconds
    const totalSeconds = Math.floor(diff / 1000);
    const hoursLeft = Math.floor(totalSeconds / 3600);
    const minutesLeft = Math.floor((totalSeconds % 3600) / 60);
    const secondsLeft = totalSeconds % 60;
    
    return {
      hours: hoursLeft,
      minutes: minutesLeft,
      seconds: secondsLeft
    };
  }

  updateDisplay() {
    const timeLeft = this.calculateTimeLeft();
    
    this.hoursElement.textContent = String(timeLeft.hours).padStart(2, '0');
    this.minutesElement.textContent = String(timeLeft.minutes).padStart(2, '0');
    this.secondsElement.textContent = String(timeLeft.seconds).padStart(2, '0');
  }
}

customElements.define('countdown-display', CountdownDisplay);
